import { render } from "./ImprovementFigures.vue?vue&type=template&id=78279ee9&scoped=true"
import script from "./ImprovementFigures.vue?vue&type=script&lang=js"
export * from "./ImprovementFigures.vue?vue&type=script&lang=js"

import "./ImprovementFigures.vue?vue&type=style&index=0&id=78279ee9&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78279ee9"]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading,QCard});
